import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { setApiBaseURL } from "@edemics/lib/api"
import { hydrateSessionFromUrlFragment } from "@edemics/contexts/auth-provider"

// Global design tokens (CSS variables, dark-mode overrides, scrollbar rules).
// Must land BEFORE Tailwind's @tailwind base so vars are defined by the time
// utilities try to hsl(var(--background)).
import "@edemics/design/styles/globals.css"

import { App } from "./App"

// Wire the shared axios instance to this app's env before any service can fire.
// Vite exposes env vars prefixed VITE_* via import.meta.env. The default
// baseURL in @edemics/lib/api is prod; only override for local / test envs.
setApiBaseURL(import.meta.env.VITE_API_URL || "https://bknd.edemics.com")

// Drain a `#token=<jwt>&user=<b64>` handoff fragment BEFORE React
// mounts, so a landing-route <Navigate /> can't strip it in a
// bottom-up effect before AuthProvider gets to read sessionStorage.
// TenantProvider also calls this, but pre-render is the earliest safe
// slot — see the doc-comment on the helper for the full ordering story.
hydrateSessionFromUrlFragment()

const root = document.getElementById("root")
if (!root) throw new Error("Missing #root element in index.html")

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <BrowserRouter
      // Opt into react-router v6 → v7 future behavior so the console isn't
      // full of deprecation warnings, and the upgrade to v7 is a no-op.
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
